var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 243)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3985",
    "data-name": "Rectangle 3985",
    width: 17.753,
    height: 19.069,
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4747",
    "data-name": "Mask Group 4747",
    transform: "translate(-19 -243)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7640",
    "data-name": "Group 7640",
    transform: "translate(21.808 245.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7637",
    "data-name": "Group 7637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7636",
    "data-name": "Group 7636",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8229",
    "data-name": "Path 8229",
    d: "M209.717,12.45v4.907h4.907",
    transform: "translate(-197.591 -11.731)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8230",
    "data-name": "Path 8230",
    d: "M42.225,18.626V12.481h9.684l4.907,4.905V30.109H42.274V28.746",
    transform: "translate(-39.783 -11.76)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8231",
    "data-name": "Path 8231",
    d: "M16.218,178.334l1.536-4.22,1.843,4.22",
    transform: "translate(-15.28 -164.047)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_821",
    "data-name": "Line 821",
    x2: 2.787,
    transform: "translate(1.206 13.549)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_822",
    "data-name": "Line 822",
    x2: 2.11,
    y2: 2.11,
    transform: "translate(10.864 12.176)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_823",
    "data-name": "Line 823",
    x1: 2.11,
    y2: 2.11,
    transform: "translate(10.866 10.064)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_824",
    "data-name": "Line 824",
    y2: 4.22,
    transform: "translate(10.864 10.064)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_825",
    "data-name": "Line 825",
    y2: 2.962,
    transform: "translate(6.428 11.326)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7639",
    "data-name": "Group 7639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7638",
    "data-name": "Group 7638",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8232",
    "data-name": "Path 8232",
    d: "M112.441,176.2h-1.267v-2.11h1.267a1.055,1.055,0,1,1,0,2.11Z",
    transform: "translate(-104.746 -164.028)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApk);
export default __webpack_public_path__ + "static/media/apk.f64e4d4972463c5f77415c35f333fd52.svg";
export { ForwardRef as ReactComponent };